import React, { Fragment } from 'react';
import { ErrorBox, Tooltip, ErrorIcon, Button } from '../styles';

export const ErrorIconWithPopup = ({
  handlePressChange,
  title = 'Error',
  text = 'This answer doesn’t make sense.',
  className = ''
}) => (<Tooltip className={className} id="box-report" title={
  <Fragment>
    <p className="title">{title}</p>
    <p>{text}</p>
    { handlePressChange && <Button onClick={handlePressChange} variant="outlined">Change Entry</Button> }
  </Fragment>
  } interactive>
  <ErrorBox><div className="circle"/><ErrorIcon/></ErrorBox>
</Tooltip>);
